import { faqItems } from "@/mocks/naruto";
import { useState } from "react";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4">
        <div className="mb-10 text-center">
          <p className="text-sm font-medium text-primary-600">常见问题</p>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">关于火影同人本子的常见问题</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            关于CP分类、阅读方式与投稿推荐，这里整理了一些读者最常问的问题。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div key={item.q} className="overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200">
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-transform ${
                      open ? "rotate-45 bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}